// extracted by mini-css-extract-plugin
module.exports = {"warrantyBadgeButton":"az_uMb","warrantyBadgeText":"az_vMb","smallPadding":"az_wMb"};